(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyHeader = document.querySelector('sticky-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.navOnScrollUp = this.getAttribute('data-sticky-type') === 'nav-on-scroll-up';
      this.nav = this.querySelector('.js-nav');
      this.headerBounds = {};
      
      this.lightScheme = this.getAttribute('data-light-scheme');
      this.darkScheme = this.getAttribute('data-dark-scheme');
      this.headerStyle = this.getAttribute('data-header-style');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1200px)').addEventListener('change', this.setHeaderHeight.bind(this));
      
      if(this.navOnScrollUp && this.nav) {
        document.documentElement.style.setProperty('--header-nav-height', `${this.nav.offsetHeight}px`);
      }

      if (this.headerIsAlwaysSticky || this.navOnScrollUp) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('details-modal.header__search details');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', (event) => {
        this.onScrollHandler(event);  
      }, false);

      this.createObserver();


if (this.predictiveSearch) {
  const observer = new MutationObserver(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const homepageOnly = this.getAttribute('data-homepage-only') === 'true';
    const isHomepage = window.location.pathname === '/' || window.location.pathname === '/index';
    
    // When search closes - check if 'open' attribute is removed
    if (!this.predictiveSearch.hasAttribute('open')) {
      // Check if menu drawer is still open
      const menuDrawer = document.querySelector('#Details-menu-drawer-container');
      const isMenuDrawerOpen = menuDrawer && menuDrawer.hasAttribute('open');
      
      // If menu drawer is open, keep light mode - don't restore
      if (isMenuDrawerOpen) {
        return;
      }
      const isOverlayMode = this.header.classList.contains('section-header') && 
                            getComputedStyle(this.header).position === 'absolute';
      
      // Calculate scroll threshold
      let scrollThreshold = 0;
      if (isOverlayMode) {
        const annBar = document.querySelector('.announcement-bar-section') ?? document.querySelector('.marquee');
        if (annBar) {
          scrollThreshold = annBar.offsetHeight;
        }
      }
      
      // Restore proper position based on scroll state
      if (scrollTop > scrollThreshold) {
        // Scrolled down - restore sticky/fixed behavior
        if (isOverlayMode) {
          this.header.style.position = 'fixed';
          this.header.style.top = '0px';
        } else {
          // Non-overlay mode - ensure sticky class is present
          this.header.style.position = '';
        }
        
        this.header.classList.add('scrolled-past-header');
        this.classList.add('scrolled-past-header');
        
        // Restore sticky header class if needed
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }
      } else {
        // At top - restore to initial state
        if (isOverlayMode) {
          this.header.style.position = 'absolute';
          
          // Restore announcement bar offset
          const annBar = document.querySelector('.announcement-bar-section') ?? document.querySelector('.marquee');
          if (annBar) {
            this.header.style.top = annBar.offsetHeight + 'px';
          }
        } else {
          // Non-overlay mode - clear inline styles
          this.header.style.position = '';
          this.header.style.top = '';
        }
        
        // Restore transparent state if applicable
        if (this.getAttribute('data-switch-to-light') === 'true' && (!homepageOnly || isHomepage)) {
          this.switchColorScheme(this.darkScheme);
          
          // Remove solid background class
          if (this.classList.contains('menu-hover-solid')) {
            this.classList.remove('menu-hover-solid');
          }
        }
        
        this.header.classList.remove('scrolled-past-header');
        this.classList.remove('scrolled-past-header');
      }
      
      // Force recalculation
      this.setStickyHeaderHeight();
    }
  });
  
  observer.observe(this.predictiveSearch, {
    attributes: true,
    attributeFilter: ['open']
  });
}
// Observer to detect when mobile drawer opens/closes
const mobileDrawers = document.querySelectorAll('#Details-menu-drawer-container');

mobileDrawers.forEach((mobileDrawer) => {
  if (!mobileDrawer) return;
  const drawerObserver = new MutationObserver(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const homepageOnly = this.getAttribute('data-homepage-only') === 'true';
    const isHomepage = window.location.pathname === '/' || window.location.pathname === '/index';
    const isDarkMode = this.getAttribute('data-header-style') === 'dark';
    const shouldSwitchColor = this.getAttribute('data-switch-to-light') === 'true';
    
    // When drawer opens
    if (mobileDrawer.hasAttribute('open')) {
      // Only switch if in dark mode and on homepage (if homepage_only is enabled)
      if (shouldSwitchColor && (!homepageOnly || isHomepage) && isDarkMode) {
        // Switch to light scheme
        this.switchColorScheme(this.lightScheme);
        
        // Add solid background class
        this.classList.add('menu-hover-solid');
      }
    } else {
      // When drawer closes
      // Only restore if at top of page and not scrolled
      if (scrollTop === 0 && shouldSwitchColor && (!homepageOnly || isHomepage)) {
        // Restore dark scheme
        this.switchColorScheme(this.darkScheme);
        
        // Remove solid background class
        this.classList.remove('menu-hover-solid');
      }
    }
  });
  
  drawerObserver.observe(mobileDrawer, {
    attributes: true,
    attributeFilter: ['open']
  });
});
  this.createObserver();
    }

    setStickyHeaderHeight() {
      if (this.stickyHeader) {
        document.documentElement.style.setProperty('--sticky-header-height', `${this.stickyHeader.offsetHeight}px`);
      }
    }
    
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.setStickyHeaderHeight();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const isOverlayMode = this.header.classList.contains('section-header') && 
                        getComputedStyle(this.header).position === 'absolute';

  // Don't run scroll logic when search is open
if (this.predictiveSearch && this.predictiveSearch.hasAttribute('open')) return;

  // Check if on homepage
  const isHomepage = window.location.pathname === '/' || window.location.pathname === '/index';
  const homepageOnly = this.getAttribute('data-homepage-only') === 'true';

  // Calculate scroll threshold based on announcement bar height
  let scrollThreshold = 0;
  if (isOverlayMode) {
    const annBar = document.querySelector('.announcement-bar-section') ?? document.querySelector('.marquee');
    if (annBar) {
      scrollThreshold = annBar.offsetHeight;
    }
  }

  if (scrollTop > scrollThreshold) {
    this.header.classList.add('scrolled-past-header');
    this.classList.add('scrolled-past-header');     
    
    if (isOverlayMode) {
      this.header.style.position = 'fixed';
    }
    
    // Only switch color on homepage if homepage_only is enabled
    if (this.getAttribute('data-switch-to-light') === 'true' && (!homepageOnly || isHomepage)) {
      this.switchColorScheme(this.lightScheme);
    }
    
    if(this.navOnScrollUp) this.header.classList.add('shopify-section-header-nav-hidden');
    this.setStickyHeaderHeight();

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    }
  } else {
    this.header.classList.remove('scrolled-past-header');
    this.classList.remove('scrolled-past-header');
    
    if (isOverlayMode) {
      this.header.style.position = 'absolute';
      
      // Restore announcement bar offset
      const annBar = document.querySelector('.announcement-bar-section') ?? document.querySelector('.marquee');
      if (annBar) {
        this.header.style.top = annBar.offsetHeight + 'px';
      }
    }
    
    // Only switch back on homepage if homepage_only is enabled
    if (this.getAttribute('data-switch-to-light') === 'true' && (!homepageOnly || isHomepage)) {
      this.switchColorScheme(this.darkScheme);
    }
    
    if(this.navOnScrollUp) this.header.classList.remove('shopify-section-header-nav-hidden');
    this.setStickyHeaderHeight();
    requestAnimationFrame(this.reset.bind(this));
  }
  
  this.currentScrollTop = scrollTop;
}

    hide() {
      if (this.headerIsAlwaysSticky || this.navOnScrollUp) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.navOnScrollUp) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.navOnScrollUp) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    switchColorScheme(scheme) {
      const currentScheme = this.getAttribute('data-color-scheme');
      this.classList.remove(currentScheme);
      this.classList.add(scheme);
      this.setAttribute('data-color-scheme', scheme);
      
      const headerStyle = scheme === this.lightScheme ? 'light' : 'dark';
      this.setAttribute('data-header-style', headerStyle);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
const headerInlineMenu = document.querySelector(".header__inline-menu");
if (headerInlineMenu) {
  const stickyHeader = document.querySelector("sticky-header");
  const headerWrapper = stickyHeader || document.querySelector(".header-wrapper");
  const header = document.querySelector(".section-header");
  let items = headerInlineMenu.querySelectorAll("details");
  let closeTimeout = null;
  let isMenuHovered = false;
  let originalScheme = null;
  let wasTransparent = false;
  
  // Function to switch to light mode on hover
  const switchToLightOnHover = () => {
    if (!headerWrapper) return;
    
    const currentScheme = headerWrapper.getAttribute('data-color-scheme');
    const lightScheme = headerWrapper.getAttribute('data-light-scheme');
    const isDarkMode = headerWrapper.getAttribute('data-header-style') === 'dark';
    
    // Check if currently transparent
    const headerWrapperBg = window.getComputedStyle(headerWrapper).backgroundColor;
    wasTransparent = headerWrapperBg === 'rgba(0, 0, 0, 0)' || headerWrapperBg === 'transparent';
    
    // Only switch if currently in dark mode
    if (isDarkMode && currentScheme !== lightScheme) {
      originalScheme = currentScheme;
      
      // Switch to light scheme
      headerWrapper.classList.remove(currentScheme);
      headerWrapper.classList.add(lightScheme);
      headerWrapper.setAttribute('data-color-scheme', lightScheme);
      headerWrapper.setAttribute('data-header-style', 'light');
      
      // Add temporary class to force solid background
      headerWrapper.classList.add('menu-hover-solid');
    }
  };
  
  // Function to restore original scheme
  const restoreOriginalScheme = () => {
    if (!headerWrapper || !originalScheme) return;
    
    const currentScheme = headerWrapper.getAttribute('data-color-scheme');
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Only restore if not scrolled (scrolled state keeps light mode)
    if (scrollTop === 0) {
      headerWrapper.classList.remove(currentScheme);
      headerWrapper.classList.add(originalScheme);
      headerWrapper.setAttribute('data-color-scheme', originalScheme);
      headerWrapper.setAttribute('data-header-style', 'dark');
      
      // Remove solid background class to restore transparency
      headerWrapper.classList.remove('menu-hover-solid');
      
      originalScheme = null;
      wasTransparent = false;
    }
  };
  
  items.forEach((item) => {
    // Prevent default click on summary
    item.addEventListener("click", (event) => {
      if (!event.target.closest('.mega-menu__content')) {
        event.preventDefault();
      }
    });
    
    // Open on hover + switch to light mode
    item.addEventListener("mouseenter", () => {
      // Clear any pending close
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      
      // Mark menu as hovered
      isMenuHovered = true;
      
      // Switch to light mode + solid background
      switchToLightOnHover();
      
      // Close other open menus
      items.forEach(otherItem => {
        if (otherItem !== item && otherItem.hasAttribute('open')) {
          otherItem.classList.add("closing");
          otherItem.querySelector("summary").setAttribute("aria-expanded", "false");
        }
      });
      
      // Open this menu immediately
      item.setAttribute("open", true);
      item.classList.remove("closing");
      item.querySelector("summary").setAttribute("aria-expanded", "true");
    });
    
    // Delay close on leave + restore scheme
    item.addEventListener("mouseleave", () => {
      // Mark menu as not hovered
      isMenuHovered = false;
      
      // Add 300ms delay before closing
      closeTimeout = setTimeout(() => {
        item.classList.add("closing");
        item.querySelector("summary").setAttribute("aria-expanded", "false");
        
        // Check if any menu is still open
        const anyMenuOpen = Array.from(items).some(i => i.hasAttribute('open') && !i.classList.contains('closing'));
        
        // Restore original scheme if no menus are open
        if (!anyMenuOpen && !isMenuHovered) {
          restoreOriginalScheme();
        }
      }, 300);
    });
    
    // Clean up after animation
    item.addEventListener("animationend", (e) => {
      if (e.animationName === "close-megamenu") {
        item.classList.remove("closing");
        item.removeAttribute("open");
        
        // Check again if we should restore scheme
        const anyMenuOpen = Array.from(items).some(i => i.hasAttribute('open'));
        if (!anyMenuOpen && !isMenuHovered) {
          restoreOriginalScheme();
        }
      }
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const quickLinkLists = document.querySelectorAll('.collection-quick-link-list').forEach((quickLinkList) => {
    let startX;
    let scrollLeft;
    let isDown;

    quickLinkList.addEventListener('mousedown', (e) => mouseIsDown(e));
    quickLinkList.addEventListener('mouseup', (e) => mouseUp(e));
    quickLinkList.addEventListener('mouseleave', (e) => mouseLeave(e));
    quickLinkList.addEventListener('mousemove', (e) => mouseMove(e));

    function mouseIsDown(e) {
      isDown = true;
      startX = e.pageX - quickLinkList.offsetLeft;
      scrollLeft = quickLinkList.scrollLeft;
    }
    function mouseUp(e) {
      isDown = false;
    }
    function mouseLeave(e) {
      isDown = false;
    }
    function mouseMove(e) {
      if (isDown) {
        e.preventDefault();
        // Move horizontally
        const x = e.pageX - quickLinkList.offsetLeft;
        const walkX = (x - startX) * 1;
        quickLinkList.scrollLeft = scrollLeft - walkX;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-link"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('quick-brand')) {
    class QuickBrand extends HTMLElement {
      connectedCallback() {
        this.lists = this.querySelectorAll('.collection-quick-link-list');
        if (!this.lists || this.lists.length === 0) return;

        this.alignment = this.dataset.alignment || 'center';

        this.classList.remove('ready');
        setTimeout(() => {
          this.lists.forEach((list) => {
            this.updateJustify(list);
            this.enableDragScroll(list);
            this.setupScrollControl(list);
          });
          this.classList.add('ready');
        }, 100);

        this.resizeHandler = () => {
          this.lists.forEach((list) => {
            this.updateJustify(list);
            this.updateScrollState(list);
          });
        };
        window.addEventListener('resize', this.resizeHandler);
      }

      disconnectedCallback() {
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
        }
      }

      updateJustify(list) {
        if (!list) return;

        const contentWidth = list.scrollWidth;
        const containerWidth = list.clientWidth;

        const fits = contentWidth <= containerWidth + 1;

        if (fits) {
          list.style.justifyContent = this.alignment === 'left' ? 'flex-start' : 'center';
        } else {
          list.style.justifyContent = 'flex-start';
        }
      }

      setupScrollControl(list) {
        if (!list) return;

        // Setup arrows click handlers
        const leftArrow = this.querySelector('.nav-arrow-left');
        const rightArrow = this.querySelector('.nav-arrow-right');

        if (leftArrow) {
          leftArrow.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            list.scrollBy({
              left: -300,
              behavior: 'smooth',
            });
          });
        }

        if (rightArrow) {
          rightArrow.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            list.scrollBy({
              left: 300,
              behavior: 'smooth',
            });
          });
        }

        // Update state on scroll
        list.addEventListener('scroll', () => {
          this.updateScrollState(list);
        });

        // Initial state
        setTimeout(() => {
          this.updateScrollState(list);
        }, 150);
      }

      updateScrollState(list) {
        if (!list) return;

        const scrollLeft = list.scrollLeft;
        const scrollWidth = list.scrollWidth;
        const clientWidth = list.clientWidth;
        const maxScroll = scrollWidth - clientWidth;

        // Check if scrollable
        const isScrollable = maxScroll > 5; // threshold 5px

        if (!isScrollable) {
          // Not scrollable - hide all controls
          this.classList.remove('show-gradient-left', 'show-gradient-right');
          this.classList.remove('show-arrow-left', 'show-arrow-right');
          return;
        }

        // Check scroll position (with threshold)
        const canScrollLeft = scrollLeft > 10;
        const canScrollRight = scrollLeft < maxScroll - 10;

        // Update classes
        this.classList.toggle('show-gradient-left', canScrollLeft);
        this.classList.toggle('show-gradient-right', canScrollRight);
        this.classList.toggle('show-arrow-left', canScrollLeft);
        this.classList.toggle('show-arrow-right', canScrollRight);
      }

      enableDragScroll(list) {
        if (!list) return;

        let startX = 0;
        let scrollLeft = 0;
        let isDown = false;
        let hasMoved = false;

        list.classList.add('draggable');

        const handleMouseDown = (e) => {
          if (e.button !== 0) return;

          isDown = true;
          hasMoved = false;
          list.classList.add('dragging');

          startX = e.pageX - list.offsetLeft;
          scrollLeft = list.scrollLeft;
        };

        const handleMouseMove = (e) => {
          if (!isDown) return;

          e.preventDefault();
          e.stopPropagation();

          const x = e.pageX - list.offsetLeft;
          const walk = (x - startX) * 1.5;

          if (Math.abs(walk) > 3) {
            hasMoved = true;
          }

          list.scrollLeft = scrollLeft - walk;
        };

        const handleMouseUp = (e) => {
          if (!isDown) return;

          isDown = false;
          list.classList.remove('dragging');
        };

        const handleMouseLeave = (e) => {
          if (isDown) {
            isDown = false;
            list.classList.remove('dragging');
          }
        };

        const handleTouchStart = (e) => {
          isDown = true;
          hasMoved = false;

          const touch = e.touches[0];
          startX = touch.pageX - list.offsetLeft;
          scrollLeft = list.scrollLeft;
        };

        const handleTouchMove = (e) => {
          if (!isDown) return;

          const touch = e.touches[0];
          const x = touch.pageX - list.offsetLeft;
          const walk = (x - startX) * 1.5;

          if (Math.abs(walk) > 5) {
            hasMoved = true;
            e.preventDefault();
          }

          list.scrollLeft = scrollLeft - walk;
        };

        const handleTouchEnd = (e) => {
          isDown = false;
        };

        const handleClick = (e) => {
          if (hasMoved) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            hasMoved = false;
            return false;
          }
        };

        list.removeEventListener('mousedown', list._mouseDownHandler);
        list.removeEventListener('mousemove', list._mouseMoveHandler);
        list.removeEventListener('mouseup', list._mouseUpHandler);
        list.removeEventListener('mouseleave', list._mouseLeaveHandler);
        list.removeEventListener('touchstart', list._touchStartHandler);
        list.removeEventListener('touchmove', list._touchMoveHandler);
        list.removeEventListener('touchend', list._touchEndHandler);
        list.removeEventListener('click', list._clickHandler, true);

        list._mouseDownHandler = handleMouseDown;
        list._mouseMoveHandler = handleMouseMove;
        list._mouseUpHandler = handleMouseUp;
        list._mouseLeaveHandler = handleMouseLeave;
        list._touchStartHandler = handleTouchStart;
        list._touchMoveHandler = handleTouchMove;
        list._touchEndHandler = handleTouchEnd;
        list._clickHandler = handleClick;

        list.addEventListener('mousedown', handleMouseDown, { passive: false });
        list.addEventListener('mousemove', handleMouseMove, { passive: false });
        list.addEventListener('mouseup', handleMouseUp, { passive: true });
        list.addEventListener('mouseleave', handleMouseLeave, { passive: true });

        list.addEventListener('touchstart', handleTouchStart, { passive: true });
        list.addEventListener('touchmove', handleTouchMove, { passive: false });
        list.addEventListener('touchend', handleTouchEnd, { passive: true });

        list.addEventListener('click', handleClick, { capture: true, passive: false });
      }
    }

    customElements.define('quick-brand', QuickBrand);
  }

  } catch(e) { console.error(e); }
})();
})();
